<div class="col-12">
    <p>EVALUE CADA UNO DE LOS FACTORES HUMANOS DEL TRABAJO PARA REVELAR SU IMPORTANCIA RELATIVA EN LA EJECUCION DEL PUESTO, COLOQUE EL NUMERO APROPIADO PARA CADA FACTOR DE ACUERDO CON LA SIGUIENTE ESCALA.</p>
    <p><b><span class="label label-info mx-1">1.Muy Bajo</span> <span class="label label-info mx-1">2.Bajo</span> <span class="label label-info mx-1">3.Significativo</span> <span class="label label-info mx-1">4.Alto</span> <span class="label label-info mx-1">5.Muy alto</span></b></p>
    <p>Solo puedes seleccionar hasta 5 elementos con puntuación 5, que son los más cruciales para el puesto. </p>
    <div class="row">
        <div *ngFor="let question of hrFormData; index as i" class="form-group col-md-6">
            <div class="row">
                <div class="col-2">
                    <input autocomplete="off" min="1" max="5" [(ngModel)]="values[i]" (ngModelChange)="checkMaxMin()" type="number"  class="form-control" [placeholder]="" >
                </div>
                <div class="col-10 f-center">
                    <span class="text-black"><small><b>{{question.text}}</b></small></span>
                </div>
            </div>
        </div>
    </div>
    <button type="button" class="btn label-info label-rounded text-white" (click)="update()" ><b>Guardar</b></button>

</div>